import Vue from "vue";
import App from "./App.vue";
import acl from './acl'

// user jQuery
window.$ = window.jQuery = require("jquery");

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax

Vue.use(Vuesax);

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

// Feather font icon
require("./assets/css/iconfont.css");

// amCharts libraries
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

import interceptors from "./config/interceptors";
interceptors();

// i18n
import VueI18n from "vue-i18n";
import messages from "./i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "th", // set locale
  messages, // set locale messages
});
// customize css
import "./assets/css/customize.scss";

// import Vcalendar from 'v-calendar'
// Vue.use(Vcalendar, {             // second is optional
//   datePickerTintColor: '#F00',
//   datePickerShowDayPopover: false
// })

import Vcalendar from '@pixelart7/v-calendar'
Vue.use(Vcalendar, {             // second is optional
  datePickerTintColor: '#F00',
  datePickerShowDayPopover: false
})

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

Vue.config.productionTip = false;

//vue-wait
import VueWait from "vue-wait";
Vue.use(VueWait);

new Vue({
  i18n,
  router,
  acl,
  store,
  wait: new VueWait({
    useVuex: true,
  }),
  render: (h) => h(App),
}).$mount("#app");
